<!-- Status filter: show both confirmed and provisional, or narrow to one -->
<div class="mb-4 flex items-center gap-3">
  <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Show:</span>
  <div class="inline-flex rounded-lg border border-gray-200 bg-gray-50 p-1 dark:border-gray-700 dark:bg-gray-800/50">
    <button
      type="button"
      (click)="setStatusFilter('Both')"
      [class.bg-white]="statusFilter === 'Both'"
      [class.text-blue-600]="statusFilter === 'Both'"
      [class.shadow-sm]="statusFilter === 'Both'"
      [class.dark:bg-gray-700]="statusFilter === 'Both'"
      class="rounded-md px-4 py-1.5 text-sm font-medium text-gray-600 transition-colors dark:text-gray-300">
      Both
    </button>
    <button
      type="button"
      (click)="setStatusFilter('Confirmed')"
      [class.bg-white]="statusFilter === 'Confirmed'"
      [class.text-blue-600]="statusFilter === 'Confirmed'"
      [class.shadow-sm]="statusFilter === 'Confirmed'"
      [class.dark:bg-gray-700]="statusFilter === 'Confirmed'"
      class="rounded-md px-4 py-1.5 text-sm font-medium text-gray-600 transition-colors dark:text-gray-300">
      Confirmed
    </button>
    <button
      type="button"
      (click)="setStatusFilter('Provisional')"
      [class.bg-white]="statusFilter === 'Provisional'"
      [class.text-blue-600]="statusFilter === 'Provisional'"
      [class.shadow-sm]="statusFilter === 'Provisional'"
      [class.dark:bg-gray-700]="statusFilter === 'Provisional'"
      class="rounded-md px-4 py-1.5 text-sm font-medium text-gray-600 transition-colors dark:text-gray-300">
      Provisional
    </button>
  </div>
</div>

<!-- Venue filter: toggle each venue on or off, colour-coded to its events -->
@if (venues.length > 0) {
  <div class="mb-4 p-4 rounded-lg border border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-800/50">
    <h3 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Venues</h3>
    <div class="flex flex-wrap gap-3">
      @for (venue of venues; track venue.id) {
        <button
          type="button"
          (click)="toggleVenue(venue.id)"
          [attr.aria-pressed]="isVenueVisible(venue.id)"
          [class.opacity-40]="!isVenueVisible(venue.id)"
          class="flex items-center space-x-2 rounded-md border border-gray-200 bg-white px-2.5 py-1 transition-opacity hover:border-gray-300 dark:border-gray-700 dark:bg-gray-800">
          <span
            class="w-4 h-4 rounded border border-gray-300 dark:border-gray-600"
            [style.background-color]="venue.color">
          </span>
          <span class="text-sm text-gray-600 dark:text-gray-400">{{ venue.name }}</span>
        </button>
      }
    </div>
  </div>
}

<div class="relative rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] lg:p-6">
  <!-- Loading overlay -->
  @if (loading) {
    <div class="absolute inset-0 z-40 flex items-center justify-center bg-black/40 backdrop-blur-sm rounded-2xl">
      <div class="flex flex-col items-center space-y-3 bg-white dark:bg-gray-800 px-6 py-4 rounded-lg shadow-lg">
        <div class="animate-spin h-6 w-6 border-3 border-blue-500 border-t-transparent rounded-full"></div>
      </div>
    </div>
  }

  <full-calendar #calendar [options]="calendarOptions"></full-calendar>
</div>
